{
    "Accessibility Menu": "辅助功能菜单",
    "Reset settings": "重置设置",
    "Close": "关闭",
    "Content Adjustments": "内容调整",
    "Adjust Font Size": "调整字体大小",
    "Highlight Title": "标题高亮",
    "Highlight Links": "链接高亮",
    "Readable Font": "易读字体",
    "Color Adjustments": "色彩调整",
    "Dark Contrast": "高对比度（黑色）",
    "Light Contrast": "高对比度（白色）",
    "High Contrast": "高对比度",
    "High Saturation": "高饱和度",
    "Low Saturation": "低饱和度",
    "Monochrome": "单色",
    "Tools": "更多设置",
    "Reading Guide": "阅读尺",
    "Stop Animations": "停止闪动",
    "Big Cursor": "放大鼠标",
    "Increase Font Size": "增加字体大小",
    "Decrease Font Size": "减小字体大小",
    "Letter Spacing": "字母间距",
    "Line Height": "行距",
    "Font Weight": "字重",
    "Dyslexia Font": "阅读障碍字体",
    "Language": "语言",
    "Open Accessibility Menu": "打开辅助功能菜单"
}